import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Configurations/AuthContext";
import { isPlanExpired, calculateTimeLeft } from "./dateUtils";
import DefaultData from "../../CompanyData/DefaultData";

export default function TopHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading, logout } = useAuth();
  const [timeLeft, setTimeLeft] = useState("");
  const [commissions, setCommissions] = useState({ earned: 0, readyToWithdraw: 0, total: 0 });
  const planIsExpired = user ? isPlanExpired(user.endDate) : false;
  
  // Check if company type is DMC
  const isDMCCompany = user?.companyType?.toLowerCase() === "dmc";
  
  // Check if user role is STAFF
  const isStaff = user?.role === "STAFF";
  
  // LOGIC 1: Determine if the countdown timer should be displayed
  const shouldDisplayCountdown =
    user &&
    !planIsExpired &&
    (user.planType?.toLowerCase() === "trail" || user.isRenewal === false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // useEffect(() => {
  //   if (!user) return;
  //   apiService.getSingle(config.GETCOMMISSIONSUMMARY)
  //     .then((data) => setCommissions({
  //       earned: data?.earned || 0,
  //       readyToWithdraw: data?.readyToWithdraw || 0,
  //       total: data?.total || 0,
  //     }))
  //     .catch(() => {});
  // }, [user]);

  // LOGIC 2: Automatic redirect hook if the plan is expired
  useEffect(() => {
    if (loading || !user) return;
    if (planIsExpired && location.pathname !== "/subscriptionplans") {
      navigate("/subscriptionplans", { replace: true });
    }
  }, [user, loading, location.pathname, navigate, planIsExpired]);

  // LOGIC 3: The countdown timer hook
  useEffect(() => {
    if (!shouldDisplayCountdown || !user?.endDate) {
      setTimeLeft("");
      return;
    }
    const intervalId = setInterval(() => {
      const timeLeftString = calculateTimeLeft(user.endDate);
      if (timeLeftString === "Plan Expired") {
        clearInterval(intervalId);
        navigate("/subscriptionplans", { replace: true }); // Force redirect when timer hits zero
      } else {
        setTimeLeft(timeLeftString);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [user, navigate, shouldDisplayCountdown]);

  if (loading) return null;

  return (
    <header
      className="shadow-sm"
      style={{
        backgroundColor: DefaultData.THEMECOLOR3,
        height: "70px",
        position: "sticky",
        top: 0,
        zIndex: 1030,
      }}
    >
      <div className="d-flex justify-content-between align-items-center h-100 px-4">
        <div className="d-flex align-items-center">
          <Link to="/dashboard">
            <img
              src="/assets/images/Zotrai.png"
              alt={`${DefaultData.DEFAULTBRANDNAME} Logo`}
              style={{ height: "30px" }}
            loading="lazy" />
          </Link>
        </div>
        <div className="d-flex align-items-center">
          {!planIsExpired && (
            <>
              
              {!isStaff && (
                <Link
                  to="/agent-website-showcase"
                  className="d-none d-sm-flex align-items-center gap-1 me-2 text-decoration-none px-2 py-1 rounded"
                  style={{ backgroundColor: DefaultData.THEMECOLOR1 }}
                  title="Manage Templates"
                >
                  <i className="ri-global-line fs-5" style={{ color: DefaultData.THEMECOLOR3 }}></i>
                  <span style={{ color: DefaultData.THEMECOLOR3, fontSize: "12px", fontWeight: 500 }}>Website</span>
                </Link>
              )}

             
              
                  {/* Wallet & Connects Dropdown */}
                <div className="dropdown d-none d-sm-flex me-2">
                  <button
                    type="button"
                    className="d-flex align-items-center gap-1 px-2 py-1 rounded border-0"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ backgroundColor: DefaultData.THEMECOLOR1, cursor: "pointer" }}
                  >
                    <i className="ri-wallet-3-line fs-5" style={{ color: DefaultData.THEMECOLOR3 }}></i>
                    <span style={{ color: DefaultData.THEMECOLOR3, fontSize: "12px", fontWeight: 500 }}>Wallet</span>
                    <i className="ri-arrow-down-s-line" style={{ color: DefaultData.THEMECOLOR3, fontSize: "14px" }}></i>
                  </button>
                  <div className="dropdown-menu dropdown-menu-end p-2" style={{ minWidth: "220px" }}>
                    <p className="text-muted mb-2 px-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Account
                    </p>

                    {/* Wallet Balance */}
                    <Link to="/topuphistory" className="text-decoration-none">
                      <div className="d-flex align-items-center justify-content-between rounded p-2 mb-2" style={{ backgroundColor: "#f3e8ff", borderLeft: "3px solid #7c3aed" }}>
                        <div>
                          <div style={{ fontSize: "10px", color: "#4c1d95", fontWeight: 600, textTransform: "uppercase" }}>Wallet Balance</div>
                          <div style={{ fontSize: "15px", fontWeight: 700, color: "#4c1d95" }}>
                            {user?.currency || ""} {Math.round(user?.walletBalance || 0)}
                          </div>
                        </div>
                        <i className="ri-wallet-3-fill" style={{ color: "#7c3aed", fontSize: "22px" }}></i>
                      </div>
                    </Link>

                    {/* Connects */}
                    <Link to="/credithistory" className="text-decoration-none">
                      <div className="d-flex align-items-center justify-content-between rounded p-2" style={{ backgroundColor: "#fff1f2", borderLeft: "3px solid #e11d48" }}>
                        <div>
                          <div style={{ fontSize: "10px", color: "#881337", fontWeight: 600, textTransform: "uppercase" }}>Connects</div>
                          <div style={{ fontSize: "15px", fontWeight: 700, color: "#881337" }}>
                            {user?.connects || 0}
                          </div>
                        </div>
                        <i className="ri-copper-coin-fill" style={{ color: "#e11d48", fontSize: "22px" }}></i>
                      </div>
                    </Link>
                  </div>
                </div>
            

             
              {!isStaff && (
                <div className="dropdown d-none d-sm-flex me-2">
                  <button
                    type="button"
                    className="d-flex align-items-center gap-1 px-2 py-1 rounded border-0"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ backgroundColor: DefaultData.THEMECOLOR1, cursor: "pointer" }}
                  >
                    <i className="ri-percent-line fs-5" style={{ color: DefaultData.THEMECOLOR3 }}></i>
                    <span style={{ color: DefaultData.THEMECOLOR3, fontSize: "12px", fontWeight: 500 }}>Commissions</span>
                    <i className="ri-arrow-down-s-line" style={{ color: DefaultData.THEMECOLOR3, fontSize: "14px" }}></i>
                  </button>
                  <div className="dropdown-menu dropdown-menu-end p-2" style={{ minWidth: "220px" }}>
                    <p className="text-muted mb-2 px-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Commissions
                    </p>

                    {/* Earned */}
                    <div className="d-flex align-items-center justify-content-between rounded p-2 mb-2" style={{ backgroundColor: "#d1fae5", borderLeft: "3px solid #059669" }}>
                      <div>
                        <div style={{ fontSize: "10px", color: "#065f46", fontWeight: 600, textTransform: "uppercase" }}>Earned</div>
                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#065f46" }}>
                          {user?.currency || ""} {Math.round(commissions.earned)}
                        </div>
                      </div>
                      <i className="ri-money-dollar-circle-fill" style={{ color: "#059669", fontSize: "22px" }}></i>
                    </div>

                    {/* Ready to Withdraw */}
                    <div className="d-flex align-items-center justify-content-between rounded p-2 mb-2" style={{ backgroundColor: "#dbeafe", borderLeft: "3px solid #2563eb" }}>
                      <div>
                        <div style={{ fontSize: "10px", color: "#1e3a8a", fontWeight: 600, textTransform: "uppercase" }}>Ready to Withdraw</div>
                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#1e3a8a" }}>
                          {user?.currency || ""} {Math.round(commissions.readyToWithdraw)}
                        </div>
                      </div>
                      <i className="ri-hand-coin-fill" style={{ color: "#2563eb", fontSize: "22px" }}></i>
                    </div>

                    {/* Total */}
                    <div className="d-flex align-items-center justify-content-between rounded p-2" style={{ backgroundColor: "#fef3c7", borderLeft: "3px solid #d97706" }}>
                      <div>
                        <div style={{ fontSize: "10px", color: "#78350f", fontWeight: 600, textTransform: "uppercase" }}>Total</div>
                        <div style={{ fontSize: "15px", fontWeight: 700, color: "#78350f" }}>
                          {user?.currency || ""} {Math.round(commissions.total)}
                        </div>
                      </div>
                      <i className="ri-bar-chart-fill" style={{ color: "#d97706", fontSize: "22px" }}></i>
                    </div>

                    <div className="mt-2 pt-1 border-top text-center">
                      <Link to="/commissions" style={{ fontSize: "11px", color: "#6c757d", textDecoration: "none" }}>
                        View all commissions <i className="ri-arrow-right-line"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <div className="dropdown">
            <button
              type="button"
              className="btn"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{
                backgroundColor: DefaultData.THEMECOLOR1,
                color: DefaultData.THEMECOLOR3,
              }}
            >
              <span className="d-flex align-items-center">
                <span className="text-start">
                  <span className="d-none d-xl-inline-block fw-medium user-name-text">
                    Welcome, {user?.brandName}
                  </span>
                  {/* <div className="d-none d-xl-block fs-12 user-name-sub-text lh-sm">
                    {user?.planType && (
                      <span
                        className="badge text-uppercase"
                        style={{
                          backgroundColor: DefaultData.THEMECOLOR3,
                          color: DefaultData.THEMECOLOR4,
                        }}
                      >
                        {user.planType}
                      </span>
                    )}
                    {shouldDisplayCountdown && timeLeft && (
                      <span className="d-block mt-1 text-white">
                        {timeLeft}
                      </span>
                    )}
                    {planIsExpired && (
                      <span className="d-block mt-1 text-danger fw-bold">
                        Plan Expired
                      </span>
                    )}
                  </div> */}
                </span>
                <i className="ri-arrow-down-s-line ms-2"></i>
              </span>
            </button>
            <div className="dropdown-menu dropdown-menu-end">
              <h6 className="dropdown-header">Welcome!</h6>
              {!planIsExpired && (
                <>
                 
                  {isStaff ? (
                    <Link className="dropdown-item" to={"/changepassword"}>
                      <i className="ri-user-line text-muted fs-4 align-middle me-1" />
                      <span className="align-middle">Profile</span>
                    </Link>
                  ) : (
                    <Link className="dropdown-item" to={"/companyprofile"}>
                      <i className="ri-user-line text-muted fs-4 align-middle me-1" />
                      <span className="align-middle">Profile</span>
                    </Link>
                  )}
                   {/* <Link className="dropdown-item" to={"/gstreport"}>
                    <i className="ri-file-chart-line text-muted fs-4 align-middle me-1" />

                    <span className="align-middle">Reports</span>
                  </Link> */}
                  
                
                  {!isStaff && !isDMCCompany && user?.isB2E && (
                    <Link className="dropdown-item" to={"/team-outing-requests"}>
                      <i className="ri-admin-line text-muted fs-4 align-middle me-1" />
                      <span className="align-middle">Corporate</span>
                    </Link>
                  )}
                   
                  {/* <Link className="dropdown-item" to={"/landingpage"}>
                    <i className="ri-earth-line text-muted fs-4 align-middle me-1" />
                    <span className="align-middle">Website</span>
                  </Link>
                  <Link className="dropdown-item" to={"/suppliers"}>
                    <i className="ri-folder-settings-line text-muted fs-4 align-middle me-1" />
                    <span className="align-middle">Settings</span>
                  </Link>
                  <Link className="dropdown-item" to={"/sasscompanieslist"}>
                    <i className="ri-folder-settings-line text-muted fs-4 align-middle me-1" />
                    <span className="align-middle">Admin Settings</span>
                  </Link>
                  <Link className="dropdown-item" to={"/agents"}>
                    <i className="ri-user-line text-muted fs-4 align-middle me-1" />
                    <span className="align-middle">Agents</span>
                  </Link> */}
                 
               
                  {!isStaff && !isDMCCompany && user?.isB2B && (
                    <Link className="dropdown-item" to={"/company/agents"}>
                      <i className="ri-admin-line text-muted fs-4 align-middle me-1" />
                      <span className="align-middle">Agents</span>
                    </Link>
                  )}
                </>
              )}
             
              {!isStaff && (
                <Link className="dropdown-item" to={"/subscriptionplans"}>
                  <i className="ri-folder-settings-line text-muted fs-4 align-middle me-1" />
                  <span className="align-middle">Plans</span>
                </Link>
              )}
              <button className="dropdown-item" onClick={handleLogout}>
                <i className="mdi mdi-logout text-muted fs-4 align-middle me-1" />
                <span className="align-middle">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}


// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../Configurations/AuthContext";
// import { isPlanExpired, calculateTimeLeft } from "./dateUtils";
// import DefaultData from "../../CompanyData/DefaultData";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";

// export default function TopHeader() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user, loading, logout } = useAuth();
//   const [timeLeft, setTimeLeft] = useState("");

//   // Live Commission Summary State
//   const [commissions, setCommissions] = useState({
//     earnedReleased: 0,
//     readyToWithdraw: 0,
//     totalCommission: 0,
//   });

//   const planIsExpired = user ? isPlanExpired(user.endDate) : false;
//   const isDMCCompany = user?.companyType?.toLowerCase() === "dmc";
//   const isStaff = user?.role === "STAFF";

//   const shouldDisplayCountdown =
//     user &&
//     !planIsExpired &&
//     (user.planType?.toLowerCase() === "trail" || user.isRenewal === false);

//   const handleLogout = () => {
//     logout();
//     navigate("/");
//   };

//   // ─── 1. FETCH LIVE COMMISSION METRICS FROM ACCOUNTING LEDGERS ───────────────
//   const fetchCommissionSummary = async () => {
//     if (!user || !user.cid || isStaff) return;
//     try {
//       // Calls: /api/MongoAccouting/agent-commission-summary/{companyId}
//       const endpoint = `${config.GETAGENTCOMMISSIONSUMMARY}/${user.cid}`;

//       const res = await apiService.getAll(endpoint);
//       if (res) {
//         setCommissions({
//           earnedReleased: res.earnedReleased || 0,
//           readyToWithdraw: res.readyToWithdraw || 0,
//           totalCommission: res.totalCommission || 0,
//         });
//       }
//     } catch (err) {
//       console.error("Error fetching commission summary in header:", err);
//     }
//   };

//   useEffect(() => {
//     if (user?.cid && !loading) {
//       fetchCommissionSummary();
//     }
//   }, [user?.cid, loading]);

//   // LOGIC 2: Automatic redirect if plan expired
//   useEffect(() => {
//     if (loading || !user) return;
//     if (planIsExpired && location.pathname !== "/subscriptionplans") {
//       navigate("/subscriptionplans", { replace: true });
//     }
//   }, [user, loading, location.pathname, navigate, planIsExpired]);

//   // LOGIC 3: Countdown timer hook
//   useEffect(() => {
//     if (!shouldDisplayCountdown || !user?.endDate) {
//       setTimeLeft("");
//       return;
//     }
//     const intervalId = setInterval(() => {
//       const timeLeftString = calculateTimeLeft(user.endDate);
//       if (timeLeftString === "Plan Expired") {
//         clearInterval(intervalId);
//         navigate("/subscriptionplans", { replace: true });
//       } else {
//         setTimeLeft(timeLeftString);
//       }
//     }, 1000);
//     return () => clearInterval(intervalId);
//   }, [user, navigate, shouldDisplayCountdown]);

//   if (loading) return null;

//   const format = (val) =>
//     Number(val || 0).toLocaleString("en-IN", { minimumFractionDigits: 0 });

//   return (
//     <header
//       className="shadow-sm"
//       style={{
//         backgroundColor: DefaultData.THEMECOLOR3,
//         height: "70px",
//         position: "sticky",
//         top: 0,
//         zIndex: 1030,
//       }}
//     >
//       <div className="d-flex justify-content-between align-items-center h-100 px-4">
//         <div className="d-flex align-items-center">
//           <Link to="/dashboard">
//             <img
//               src="/assets/images/Zotrai.png"
//               alt={`${DefaultData.DEFAULTBRANDNAME} Logo`}
//               style={{ height: "30px" }}
//               loading="lazy"
//             />
//           </Link>
//         </div>

//         <div className="d-flex align-items-center">
//           {!planIsExpired && (
//             <>
//               {!isStaff && (
//                 <Link
//                   to="/agent-website-showcase"
//                   className="d-none d-sm-flex align-items-center gap-1 me-2 text-decoration-none px-2 py-1 rounded"
//                   style={{ backgroundColor: DefaultData.THEMECOLOR1 }}
//                   title="Manage Templates"
//                 >
//                   <i className="ri-global-line fs-5" style={{ color: DefaultData.THEMECOLOR3 }}></i>
//                   <span style={{ color: DefaultData.THEMECOLOR3, fontSize: "12px", fontWeight: 500 }}>
//                     Website
//                   </span>
//                 </Link>
//               )}

//               {/* Wallet & Connects Dropdown */}
//               <div className="dropdown d-none d-sm-flex me-2">
//                 <button
//                   type="button"
//                   className="d-flex align-items-center gap-1 px-2 py-1 rounded border-0"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                   style={{ backgroundColor: DefaultData.THEMECOLOR1, cursor: "pointer" }}
//                 >
//                   <i className="ri-wallet-3-line fs-5" style={{ color: DefaultData.THEMECOLOR3 }}></i>
//                   <span style={{ color: DefaultData.THEMECOLOR3, fontSize: "12px", fontWeight: 500 }}>
//                     Wallet
//                   </span>
//                   <i className="ri-arrow-down-s-line" style={{ color: DefaultData.THEMECOLOR3, fontSize: "14px" }}></i>
//                 </button>
//                 <div className="dropdown-menu dropdown-menu-end p-2" style={{ minWidth: "220px" }}>
//                   <p className="text-muted mb-2 px-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
//                     Account
//                   </p>

//                   <Link to="/topuphistory" className="text-decoration-none">
//                     <div className="d-flex align-items-center justify-content-between rounded p-2 mb-2" style={{ backgroundColor: "#f3e8ff", borderLeft: "3px solid #7c3aed" }}>
//                       <div>
//                         <div style={{ fontSize: "10px", color: "#4c1d95", fontWeight: 600, textTransform: "uppercase" }}>
//                           Wallet Balance
//                         </div>
//                         <div style={{ fontSize: "15px", fontWeight: 700, color: "#4c1d95" }}>
//                           {user?.currency || "INR"} {Math.round(user?.walletBalance || 0).toLocaleString("en-IN")}
//                         </div>
//                       </div>
//                       <i className="ri-wallet-3-fill" style={{ color: "#7c3aed", fontSize: "22px" }}></i>
//                     </div>
//                   </Link>

//                   <Link to="/credithistory" className="text-decoration-none">
//                     <div className="d-flex align-items-center justify-content-between rounded p-2" style={{ backgroundColor: "#fff1f2", borderLeft: "3px solid #e11d48" }}>
//                       <div>
//                         <div style={{ fontSize: "10px", color: "#881337", fontWeight: 600, textTransform: "uppercase" }}>
//                           Connects
//                         </div>
//                         <div style={{ fontSize: "15px", fontWeight: 700, color: "#881337" }}>
//                           {user?.connects || 0}
//                         </div>
//                       </div>
//                       <i className="ri-copper-coin-fill" style={{ color: "#e11d48", fontSize: "22px" }}></i>
//                     </div>
//                   </Link>
//                 </div>
//               </div>

//               {/* ─── LIVE COMMISSIONS DROPDOWN (CONNECTED TO ESCROW ENGINE) ─── */}
//               {!isStaff && (
//                 <div className="dropdown d-none d-sm-flex me-2">
//                   <button
//                     type="button"
//                     className="d-flex align-items-center gap-1 px-2 py-1 rounded border-0"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                     style={{ backgroundColor: DefaultData.THEMECOLOR1, cursor: "pointer" }}
//                   >
//                     <i className="ri-percent-line fs-5" style={{ color: DefaultData.THEMECOLOR3 }}></i>
//                     <span style={{ color: DefaultData.THEMECOLOR3, fontSize: "12px", fontWeight: 500 }}>
//                       Commissions
//                     </span>
//                     <i className="ri-arrow-down-s-line" style={{ color: DefaultData.THEMECOLOR3, fontSize: "14px" }}></i>
//                   </button>
//                   <div className="dropdown-menu dropdown-menu-end p-2" style={{ minWidth: "240px" }}>
//                     <p className="text-muted mb-2 px-1" style={{ fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
//                       Commissions Escrow
//                     </p>

//                     {/* 🟢 EARNED (Transferred to Active Wallet) */}
//                     <div className="d-flex align-items-center justify-content-between rounded p-2 mb-2" style={{ backgroundColor: "#d1fae5", borderLeft: "3px solid #059669" }}>
//                       <div>
//                         <div style={{ fontSize: "10px", color: "#065f46", fontWeight: 600, textTransform: "uppercase" }}>
//                           Earned (In Wallet)
//                         </div>
//                         <div style={{ fontSize: "15px", fontWeight: 700, color: "#065f46" }}>
//                           {user?.currency || "INR"} {format(commissions.earnedReleased)}
//                         </div>
//                       </div>
//                       <i className="ri-money-dollar-circle-fill" style={{ color: "#059669", fontSize: "22px" }}></i>
//                     </div>

//                     {/* 🔵 READY TO WITHDRAW (Departure Passed) */}
//                     <div className="d-flex align-items-center justify-content-between rounded p-2 mb-2" style={{ backgroundColor: "#dbeafe", borderLeft: "3px solid #2563eb" }}>
//                       <div>
//                         <div style={{ fontSize: "10px", color: "#1e3a8a", fontWeight: 600, textTransform: "uppercase" }}>
//                           Ready to Withdraw
//                         </div>
//                         <div style={{ fontSize: "15px", fontWeight: 700, color: "#1e3a8a" }}>
//                           {user?.currency || "INR"} {format(commissions.readyToWithdraw)}
//                         </div>
//                       </div>
//                       <i className="ri-hand-coin-fill" style={{ color: "#2563eb", fontSize: "22px" }}></i>
//                     </div>

//                     {/* 🟡 TOTAL (All Time Commission) */}
//                     <div className="d-flex align-items-center justify-content-between rounded p-2" style={{ backgroundColor: "#fef3c7", borderLeft: "3px solid #d97706" }}>
//                       <div>
//                         <div style={{ fontSize: "10px", color: "#78350f", fontWeight: 600, textTransform: "uppercase" }}>
//                           Total Escrow
//                         </div>
//                         <div style={{ fontSize: "15px", fontWeight: 700, color: "#78350f" }}>
//                           {user?.currency || "INR"} {format(commissions.totalCommission)}
//                         </div>
//                       </div>
//                       <i className="ri-bar-chart-fill" style={{ color: "#d97706", fontSize: "22px" }}></i>
//                     </div>

//                     <div className="mt-2 pt-2 border-top text-center">
//                       <Link to="/commissions" className="fw-bold" style={{ fontSize: "11.5px", color: "#0d6efd", textDecoration: "none" }}>
//                         View all commissions &rarr;
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {/* User Account Menu */}
//           <div className="dropdown">
//             <button
//               type="button"
//               className="btn"
//               data-bs-toggle="dropdown"
//               aria-haspopup="true"
//               aria-expanded="false"
//               style={{
//                 backgroundColor: DefaultData.THEMECOLOR1,
//                 color: DefaultData.THEMECOLOR3,
//               }}
//             >
//               <span className="d-flex align-items-center">
//                 <span className="text-start">
//                   <span className="d-none d-xl-inline-block fw-medium user-name-text">
//                     Welcome, {user?.brandName || user?.companyname}
//                   </span>
//                 </span>
//                 <i className="ri-arrow-down-s-line ms-2"></i>
//               </span>
//             </button>
//             <div className="dropdown-menu dropdown-menu-end">
//               <h6 className="dropdown-header">Welcome!</h6>
//               {!planIsExpired && (
//                 <>
//                   {isStaff ? (
//                     <Link className="dropdown-item" to={"/changepassword"}>
//                       <i className="ri-user-line text-muted fs-4 align-middle me-1" />
//                       <span className="align-middle">Profile</span>
//                     </Link>
//                   ) : (
//                     <Link className="dropdown-item" to={"/companyprofile"}>
//                       <i className="ri-user-line text-muted fs-4 align-middle me-1" />
//                       <span className="align-middle">Profile</span>
//                     </Link>
//                   )}

//                   {!isStaff && !isDMCCompany && user?.isB2E && (
//                     <Link className="dropdown-item" to={"/team-outing-requests"}>
//                       <i className="ri-admin-line text-muted fs-4 align-middle me-1" />
//                       <span className="align-middle">Corporate</span>
//                     </Link>
//                   )}

//                   {!isStaff && !isDMCCompany && user?.isB2B && (
//                     <Link className="dropdown-item" to={"/company/agents"}>
//                       <i className="ri-admin-line text-muted fs-4 align-middle me-1" />
//                       <span className="align-middle">Agents</span>
//                     </Link>
//                   )}
//                 </>
//               )}

//               {!isStaff && (
//                 <Link className="dropdown-item" to={"/subscriptionplans"}>
//                   <i className="ri-folder-settings-line text-muted fs-4 align-middle me-1" />
//                   <span className="align-middle">Plans</span>
//                 </Link>
//               )}
//               <button className="dropdown-item" onClick={handleLogout}>
//                 <i className="mdi mdi-logout text-muted fs-4 align-middle me-1" />
//                 <span className="align-middle">Logout</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }